/**
 * The metasphere toolbar is not a pure settings toggle: it also requires an orbital/tree
 * organism (`Atlas` or `ArmillaryView`) to be present, because the toolbar's panels are
 * scoped to the sphere those organisms select. Both the runtime grid and the composer's
 * WYSIWYG chrome preview must agree on that rule, or an author arranges a layout against
 * chrome that never appears at runtime.
 */

/** The organism component names whose presence enables the metasphere toolbar. */
const TOOLBAR_ENABLING_ORGANISMS = ['Atlas', 'ArmillaryView'];

/**
 * @param componentNames every organism/component name present in the document or layout.
 * @param showMetasphereToolbar the document's `settings.showMetasphereToolbar` (opt-out;
 *   `undefined` means "show").
 */
export function shouldShowMetaspaceToolbar(
  componentNames: readonly string[],
  showMetasphereToolbar: boolean | undefined
): boolean {
  const hasEnablingOrganism = componentNames.some((name) => TOOLBAR_ENABLING_ORGANISMS.includes(name));
  return hasEnablingOrganism && showMetasphereToolbar !== false;
}
